import { reactive } from 'vue'
import { sleep } from '../time';


export const usePoll = <T = any>(props: {
  fun: (args: { finish: ((data: T | null | undefined) => void), update: ((data: T | null | undefined) => void) }) => Promise<void>,
  handleError?: (e:  unknown) => void | Promise<void>,
  delay: number
}) => {
  const delay = props.delay ?? 500;
  const state = reactive<{
    loopHandle: ReturnType<typeof requestAnimationFrame> | null,
    stopped: boolean
  }>({
    loopHandle: null,
    stopped: false
  });

  const stop = () => {
    if (state.loopHandle === null) return;
    cancelAnimationFrame(state.loopHandle);
    state.loopHandle = null;
    state.stopped = true;
  }

  const loop = async (callback?: (data: T | null | undefined) => (void | Promise<void>)) => {
    await props.fun({
      finish: async (data: T | null | undefined) => {
        console.log('finish()');
        stop();
        if (callback) {
          try {
            await callback(data);
          } catch (e) {
            if (props.handleError) {
              props.handleError(e);
            }
            console.error(e);
          }
        }
      },
      update: async (data: T | null | undefined) => {
        console.log('update()');
        if (callback) {
          try {
            await callback(data);
          } catch (e) {
            if (props.handleError) {
              await props.handleError(e);
            }
            console.error(e);
          }
        }
      }
    })

    await sleep(delay);
  }


  const start = (callback?: (data: T | null | undefined) => (void | Promise<void>)) => {
    stop();
    state.stopped = false;

    return new Promise<T | null | undefined>((resolve, reject) => {
      const loopFun = async () => {
        await loop(async (data) => {
          if (callback) {
            try {
              await callback(data);
            } catch(e) {
              if (props.handleError) {
                await props.handleError(e);
              }
              console.error(e);
              reject(e);
            }
          }

          if (state.stopped) {
            console.log('stopped!');
            resolve(data);
            return;
          }

          await sleep(delay);
          state.loopHandle = requestAnimationFrame(loopFun);
        })
      };
      state.loopHandle = requestAnimationFrame(loopFun)
    })

  }

  return { start, stop, state };

}

//export const usePoll = <T = any>(props: {
//  fun: (args: { finish: ((data: T | null | undefined) => void), update: ((data: T | null | undefined) => void) }) => Promise<void>
//  handleError?: (e: unknown) => void | Promise<void>
//  delay: number
//}) => {
//  const state = reactive<{
//    timer: ReturnType<typeof setInterval> | undefined,
//  }>({
//    timer: undefined
//  })
//
//  const stop = () => {
//    if (typeof state.timer === 'undefined') return
//    clearInterval(state.timer)
//    state.timer = undefined
//  }
//
//
//
//
//  const start = (callback?: (data: T | null | undefined) => (void | Promise<void>)) => {
//    return new Promise<T | null | undefined>((resolve, reject) => {
//      stop()
//      state.timer = setInterval(async () => {
//        try {
//          await props.fun({
//            finish: async (data: T | null | undefined) => {
//              stop();
//              resolve(data);
//              if (data && callback) {
//                await callback(data);
//              }
//              stop();
//            },
//            update: async (data: T | null | undefined) => {
//              if (callback) {
//                await callback(data);
//              }
//            }
//          })
//        } catch (e) {
//          console.error(e)
//          if (props.handleError) {
//            await props.handleError(e)
//          }
//          stop()
//          reject(e);
//        }
//      }, props.delay)
//    })
//  }
//
//  if (isComponentScope()) {
//    onUnmounted(stop)
//  }
//
//  return { state, stop, start }
//}
